/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_SubtitleInputs */

const en_pc_dl_subtitle = /** @type {(inputs: Pc_Dl_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free on every platform. Pick your system and follow the steps below.`)
};

const zh_pc_dl_subtitle = /** @type {(inputs: Pc_Dl_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有平台免费。选择你的系统，按下面的步骤操作。`)
};

/**
* | output |
* | --- |
* | "Free on every platform. Pick your system and follow the steps below." |
*
* @param {Pc_Dl_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_subtitle = /** @type {((inputs?: Pc_Dl_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_subtitle(inputs)
	return zh_pc_dl_subtitle(inputs)
});
export { pc_dl_subtitle as "pc.dl.subtitle" }